/** @jsxImportSource @emotion/react */
import Modal from "react-modal";
import { useEffect, useState } from "react";
import WelcomePage from "./onboarding-modal-page/welcome";
import RegisterVisitPage from "./onboarding-modal-page/registerVisit";
import SendingVisitInfoPage from "./onboarding-modal-page/sendingVisitInfo";
import ConfirmVisitPage from "./onboarding-modal-page/confirmVisit";
import { useRecoilState } from "recoil";
import { userInfo } from "recoil/recoilState";
import { gaEvent } from "utils/ga-utils";
import { updateVisitorsOnboardingModalDismissed } from "apis/visitors/modal";
import { set } from "lodash";

type Props = {
  isFirst: boolean;
  modalIsOpen: boolean;
  closeModal: () => void;
};

Modal.setAppElement("#root");

const modalStyle = {
  content: {
    maxWidth: 1000,
    height: 700,
    width: "70%",

    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: 0,
    transform: "translate(-50%, -50%)",

    borderRadius: "15px",
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1000,
  },
};

export default function OnboardingModal(props: Props) {
  const { isFirst, modalIsOpen, closeModal } = props;
  const [currentPageIndex, setCurrentPageIndex] = useState<number>(isFirst ? 0 : 1);

  useEffect(() => {
    if (modalIsOpen) {
      if (isFirst) {
        gaEvent("첫 온보딩 오픈");
      } else {
        gaEvent("온보딩 오픈");
      }
      setCurrentPageIndex(0);
    }
  }, [modalIsOpen]);

  const onClickSkip = () => {
    if (isFirst) {
      onClickFinish();
    } else {
      closeModal();
    }

    if (isFirst) {
      gaEvent("첫 온보딩 - 건너뛰기");
    } else {
      gaEvent("온보딩 - 건너뛰기");
    }
  };

  const onClickBack = () => {
    setCurrentPageIndex(currentPageIndex - 1);
  };

  const onClickNext = () => {
    setCurrentPageIndex(currentPageIndex + 1);
  };

  const onClickFinish = async () => {
    if (isFirst) {
      await updateVisitorsOnboardingModalDismissed();
      gaEvent("첫 온보딩 - 완료");
    } else {
      gaEvent("온보딩 - 완료");
    }

    closeModal();
  };

  return (
    <Modal
      isOpen={modalIsOpen}
      closeTimeoutMS={400}
      style={modalStyle}
      onRequestClose={isFirst ? () => {} : closeModal}
    >
      {currentPageIndex === 0 && <WelcomePage onClickNext={onClickNext} onClickSkip={onClickSkip} />}
      {currentPageIndex === 1 && (
        <RegisterVisitPage
          isFirst={isFirst}
          onClickNext={onClickNext}
          onClickBack={onClickBack}
          onClickSkip={onClickSkip}
        />
      )}
      {currentPageIndex === 2 && (
        <SendingVisitInfoPage
          isFirst={isFirst}
          onClickNext={onClickNext}
          onClickBack={onClickBack}
          onClickSkip={onClickSkip}
        />
      )}
      {currentPageIndex === 3 && (
        <ConfirmVisitPage isFirst={isFirst} onClickFinish={onClickFinish} onClickBack={onClickBack} />
      )}
    </Modal>
  );
}
